import store from '../../redux/store';
import { logout as sliceLogout } from '../../redux/authSlice';
import { callAuthAPI, isSuccessCode } from '../../utils/apiUtils';
import { ROUTE_BACK_OFFICE_LOGIN } from '../../constants';

class AuthService {
  getLoggedInUserInfo() {
    return store.getState().auth.user;
  }

  async login(credentials) {
    try {
      const response = await callAuthAPI('bo/login', credentials, 'post', true);
      if (!isSuccessCode(response.status)) {
        throw new Error('Login failed');
      }
      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  }

  async verifyTwoFactor(payload) {
    try {
      const response = await callAuthAPI('bo/login/verify-2fa', payload, 'post', true);
      if (!isSuccessCode(response.status)) {
        throw new Error('Verification failed');
      }
      return response.data;
    } catch (error) {
      console.error('2FA Verification error:', error);
      throw error;
    }
  }

  async validateUser() {
    try {
      const response = await callAuthAPI('bo/validate', undefined, 'get', true);
      return response.data.user;
    } catch {
      return null;
    }
  }

  async logout(navigate) {
    return callAuthAPI('bo/logout', {}, 'post', true)
      .then(response => {
        store.dispatch(sliceLogout());
        navigate(ROUTE_BACK_OFFICE_LOGIN);
        return response;
      });
  }

  hasPermission(permissionName) {
    const userInfo = this.getLoggedInUserInfo();
    if (!userInfo) return false;
    return !!userInfo?.permissions?.[permissionName];
  }

  hasEntityPermission(entityName, permissionPrefix) {
    return this.hasPermission(permissionPrefix + entityName);
  }

  getContinueWritingWordCount() {
    const userInfo = this.getLoggedInUserInfo();
    if (!userInfo) return 0;
    return userInfo.continueWritingWordCount ?? 100;
  }

  hasDashboardViewPermission() {
    return !!this.getLoggedInUserInfo();
  }
}

const authService = new AuthService();
export default authService;